(ns common.schema.entities.counterparty-diligence.project.core
  (:require [common.features.plan :as plan]
            [common.schema.entities.counterparty-diligence.project :as project-counterparty-diligence]
            [common.schema.entities.counterparty-diligence.util :as counterparty-diligence-util]))

;; Verbatim copy of common.schema.entity-types's oppo-read-check-fn and
;; exit-oppo-read-check-fn (entity_types.cljc:352-371) - required here, not
;; there, to avoid a circular namespace dependency. Reproduced inline
;; instead of requiring the newer, simpler
;; common.schema.entities.oppo.permissions/read-permissions? (used by oppo's
;; own new-registry entry), which intentionally dropped the
;; :account-access-to-pipelines check - that simplification is fine for
;; oppo's OWN read gate, but this project-counterparty-diligence check needs
;; the ORIGINAL, more precise pipeline-scoped logic to correctly decide
;; whether a light-access user can see a diligence via the deal/exit it
;; originated from.
(defn- oppo-read-check-fn
  [{:keys [account-current-permissions role target entity]}]
  (or (and (= role :role/guest-buy-side)
           target
           (= (:db/id entity) (:db/id target)))
      (and (contains? (:account-modules account-current-permissions) :module/dealflow)
           (contains? (:account-access-to-pipelines account-current-permissions)
                      (->> entity :oppo/pipeline :db/id)))))

(defn- exit-oppo-read-check-fn
  [{:keys [account-current-permissions entity]}]
  (and (contains? (:account-modules account-current-permissions) :module/exit-process-management)
       (contains? (:account-access-to-pipelines account-current-permissions)
                  (->> entity :exit-opportunity/pipeline :db/id))))

;; Verbatim copy of common.schema.entity-types's existing
;; project-counterparty-diligence entry (entity_types.cljc:2439-2444, sharing
;; counterparty-diligence-read-check-fn at lines 505-529) - required here,
;; not there, to avoid a circular namespace dependency. Unlike
;; company/person-counterparty-diligence, project has a real
;; :project-counterparty-diligence/source-entity ref (to an oppo or
;; exit-opportunity), so a light-access user (:module/counterparty-diligence,
;; without -admin) can also read it via read access to that source entity -
;; keep this branch in sync with the company/person core.cljc copies if the
;; shared admin-only branch ever changes.
(defn- counterparty-diligence-read-check-fn
  [{:keys [entity tenant tenant-plan role account-current-permissions] :as ctx}]
  (let [feature-available? (plan/available :feature/counterparty-diligence tenant role tenant-plan)
        account-modules (:account-modules account-current-permissions)
        light-access? (contains? account-modules :module/counterparty-diligence)
        admin? (contains? account-modules :module/counterparty-diligence-admin)
        source-entity (:project-counterparty-diligence/source-entity entity)
        access-to-source-entity? (when source-entity
                                   (case (:entity/type source-entity)
                                     :entity.type/oppo (oppo-read-check-fn (assoc ctx :entity source-entity))
                                     :entity.type/exit-opportunity (exit-oppo-read-check-fn (assoc ctx :entity source-entity))
                                     false))]
    (and feature-available?
         (or admin?
             (and light-access? access-to-source-entity?)))))

(def entity-type-definition
  {:entity-type                  :entity.type/project-counterparty-diligence
   :schema                       project-counterparty-diligence/schema
   :name                         {:en "Counterparty Diligence - Project"}
   :plural                       {:en "Project diligences"}
   :icon                         :fa-folder-shield
   :create-icon                  :fa-folder-shield
   :read-permissions-check-fn    counterparty-diligence-read-check-fn
   :disable-permissions-check-fn counterparty-diligence-util/admin-delete-check-fn
   ;; No pre-existing legacy dedicated OpenSearch index at all for this
   ;; entity type - :search-index? left unset/true so the generic
   ;; materialization pipeline creates a genuinely new dedicated index, same
   ;; as company/person-counterparty-diligence/sale-agreement (see
   ;; ai/mistakes.md). Project has no :screening-status field at all (only
   ;; company/person do), so its last default column is :note instead -
   ;; confirmed accessible for this dev tenant (no
   ;; tenant/field-configurations override exists for any of the three
   ;; counterparty-diligence entity types at all), so the kanban
   ;; header/footer-field-accessibility gap logged in ai/mistakes.md doesn't
   ;; bite here, but re-verify live if this tenant's field configuration
   ;; ever changes.
   :search                       {:result/title-attr    :project-counterparty-diligence/project-name
                                  :list/default-columns [:project-counterparty-diligence/project-name
                                                         :counterparty-diligence/status
                                                         :project-counterparty-diligence/template
                                                         :counterparty-diligence/note]
                                  :views {:grid {:po-default-field-paths [[:project-counterparty-diligence/project-name]
                                                                          [:counterparty-diligence/status]
                                                                          [:project-counterparty-diligence/template]
                                                                          [:counterparty-diligence/note]]
                                                 :mandatory-field-paths [[:project-counterparty-diligence/project-name]]}}}})
